"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _hooks = require("../../../hooks");

var _components = require("../../../components");

var _LocationCardModule = _interopRequireDefault(require("./LocationCard.module.scss"));

var _utils = require("../../../utils");

var _excluded = ["address", "cellType", "dataTest", "diningOption", "innerRef", "name", "formattedDistance", "onEnterMenu", "onSeeAllRestaurants", "isPreorderRequired", "onEnterMenuScheduleLater", "isOpen", "orderButtonCopy", "orderTypeHours", "restaurantGroups"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Caret = function Caret() {
  return /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      marginLeft: "0.45rem"
    }
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "7",
    height: "10",
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-3.85753e-07 1.175L3.81667 5L-5.13609e-08 8.825L1.175 10L6.175 5L1.175 -5.13609e-08L-3.85753e-07 1.175Z",
    fill: "#1A1A1A"
  })));
};

var LocationCardType8 = function LocationCardType8(_ref) {
  var address = _ref.address,
      cellType = _ref.cellType,
      dataTest = _ref.dataTest,
      diningOption = _ref.diningOption,
      innerRef = _ref.innerRef,
      name = _ref.name,
      formattedDistance = _ref.formattedDistance,
      onEnterMenu = _ref.onEnterMenu,
      onSeeAllRestaurants = _ref.onSeeAllRestaurants,
      _ref$isPreorderRequir = _ref.isPreorderRequired,
      isPreorderRequired = _ref$isPreorderRequir === void 0 ? false : _ref$isPreorderRequir,
      onEnterMenuScheduleLater = _ref.onEnterMenuScheduleLater,
      isOpen = _ref.isOpen,
      orderButtonCopy = _ref.orderButtonCopy,
      orderTypeHours = _ref.orderTypeHours,
      restaurantGroups = _ref.restaurantGroups,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      buttons = _useTemplate$useCell.buttons,
      views = _useTemplate$useCell.views,
      labelTextStyles = _useTemplate$useCell.labelTextStyles;

  var hoursProps = function hoursProps(orderType) {
    return _objectSpread({
      primaryType: labelTextStyles.tertiary,
      secondaryType: labelTextStyles.secondary,
      isPreorderRequired: isPreorderRequired
    }, orderTypeHours(orderType));
  };

  var _hoursProps = hoursProps(diningOption),
      hours = _hoursProps.hours;

  var dayOfWeek = new Date().getDay();
  var todayHours = hours.find(function (hour) {
    return hour.days.includes(dayOfWeek);
  });
  var timeStrings = todayHours.hours.split("-");
  var isCurrentlyOpen = (0, _utils.currentTimeIsBetween)(timeStrings[0], timeStrings[1]);
  return /*#__PURE__*/_react["default"].createElement(_components.View, {
    Component: "li",
    className: [_LocationCardModule["default"].locationCard, "location-card"],
    innerRef: innerRef,
    dataTest: dataTest,
    type: views.background,
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement(_components.View, {
    className: _LocationCardModule["default"]["locationCard-top"],
    type: views.primary,
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement(_components.Box, {
    className: _LocationCardModule["default"]["locationCard-top-header"],
    justify: "between"
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    role: "heading",
    "aria-level": "3",
    "aria-label": name,
    className: _LocationCardModule["default"].title,
    type: labelTextStyles.primary
  }, name), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    className: _LocationCardModule["default"].distance,
    type: labelTextStyles.primary
  }, formattedDistance.length > 0 && "".concat(formattedDistance.split(" ")[0], " mi (nearest)"))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_components.Box, {
    className: _LocationCardModule["default"]["locationCard-top-addressContainer"]
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary
  }, "".concat(address[0], "\n                    ").concat(address[1]))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: "5px 0px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.quaternary,
    className: _LocationCardModule["default"]["".concat(isCurrentlyOpen ? "locationCard-top-open" : "locationCard-top-close")]
  }, isCurrentlyOpen ? "Open now" : "Closed"), isCurrentlyOpen && todayHours ? /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary
  }, "\u2022 Open ", timeStrings.join(' to ')) : /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary
  }, "\u2022 Open ", timeStrings.join(' to '))))))), /*#__PURE__*/_react["default"].createElement(_components.View, {
    className: _LocationCardModule["default"]["locationCard-bottom"],
    type: views.secondary,
    direction: "column",
    justify: "between"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onSeeAllRestaurants
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    className: _LocationCardModule["default"]["locationCard-bottom-title"],
    type: labelTextStyles.quaternary,
    style: {
      cursor: "pointer"
    }
  }, "See all ", restaurantGroups.length, " restaurants in this location", /*#__PURE__*/_react["default"].createElement(Caret, null)))), /*#__PURE__*/_react["default"].createElement(_components.Box, null, isPreorderRequired ? /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    className: _LocationCardModule["default"]["locationCard-button"],
    type: buttons.secondary,
    onClick: onEnterMenuScheduleLater
  }, "PREORDER") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    style: {
      marginRight: "2rem"
    },
    className: _LocationCardModule["default"]["locationCard-button"],
    type: buttons.secondary,
    onClick: onEnterMenuScheduleLater
  }, "SCHEDULE IT"), /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    className: _LocationCardModule["default"]["locationCard-button"],
    type: buttons.primary,
    onClick: onEnterMenu,
    disabled: !isOpen
  }, orderButtonCopy))));
};

var _default = /*#__PURE__*/_react["default"].memo(LocationCardType8);

exports["default"] = _default;